<div class="container">
    <div class="insurer-authorization">
        <div class="insurer-authorization__header">
            {{ translationComponentKey + '.header' | translate }}
        </div>
        <div class="insurer-authorization__image">
            <img [src]="imageUrl">
        </div>
        <div class="insurer-authorization__text">
            <div [innerHTML]="status.message |safeHtml"></div>
        </div>
        <div class="insurer-authorization__action">
            <div class="insurer-authorization__buttons">
                <button class="btn btn--secondary" (click)="confirm()">
                    {{translationComponentKey + '.confirmButton' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>
